import { Link } from 'react-router-dom';
import type { Series } from '@/mocks/series';
import { statusInfo, formatHeat } from '@/utils/series';

export default function SeriesCard({ series }: { series: Series }) {
  const st = statusInfo[series.status];
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-background-300">
      <Link to={`/story/${series.id}`} className="relative block overflow-hidden" aria-label={series.title}>
        <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-200">
          <img
            src={series.cover}
            alt={`${series.title} 系列封面`}
            title={`${series.title} 连续剧追更`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <span
          className={`absolute left-3 top-3 flex items-center gap-1 whitespace-nowrap rounded-full px-3 py-1 text-xs font-bold text-background-50 ${st.badge}`}
        >
          <span className="h-1.5 w-1.5 rounded-full bg-background-50/90"></span>
          {st.text}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 whitespace-nowrap rounded-full bg-background-950/55 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
          <i className="ri-fire-line text-secondary-400"></i>
          {formatHeat(series.heat)}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center gap-2 text-xs">
          <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-secondary-100 px-2 py-0.5 font-medium text-secondary-900">
            <i className="ri-price-tag-line text-accent-700"></i>
            {series.categoryName}
          </span>
          <span className="text-foreground-400">{series.latestEp}更新</span>
          <span className="ml-auto whitespace-nowrap text-foreground-400">
            <i className="ri-time-line mr-0.5"></i>{series.updated}
          </span>
        </div>

        <h3 className="mt-2.5 text-base font-bold leading-snug text-foreground-950 transition-colors md:text-lg">
          <Link to={`/story/${series.id}`} className="hover:text-primary-600">
            {series.title}
          </Link>
        </h3>

        <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{series.summary}</p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {series.tags.map((t) => (
            <span key={t} className="whitespace-nowrap rounded-full bg-background-100 px-2.5 py-0.5 text-xs text-foreground-600">
              #{t}
            </span>
          ))}
        </div>

        <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3">
          <span className="text-xs font-medium text-foreground-500">
            {series.totalEps}
          </span>
          <Link
            to={`/story/${series.id}`}
            className="inline-flex items-center whitespace-nowrap text-sm font-bold text-primary-600"
          >
            去追更
            <i className="ri-arrow-right-line ml-1 transition-transform group-hover:translate-x-1"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}